module.exports = __webpack_public_path__ + "images/logo_schwarz-6bf348dd789d5cde4e8e19bcd502f411.png";